import { createAction } from "redux-starter-kit";

import { NEXT_STEP_BY_NAME } from "../types";

const moveToStep = step => createAction(NEXT_STEP_BY_NAME)(step);

export default moveToStep;
